import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { DevisFormComponent } from '../../devis-form/devis-form.component';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';

@Component({
  selector: 'app-user-information',
  templateUrl: './user-information.component.html',
  styleUrls: ['./user-information.component.css']
})
export class UserInformationComponent implements OnInit {
  informationForm: FormGroup;
  data_dialog_value;
  limit_: number;
  constructor(public fb: FormBuilder, private http: HttpClient, private hpService: HpService,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA)
    public data_dialog: any) {
    this.limit_ = this.hpService.getLimit();

  }

  ngOnInit() {
    this.data_dialog_value = parseInt(this.data_dialog.name);
    this.informationForm = this.fb.group({
      gender: [''],
      userNom: ['', Validators.required],
      userPrenom: ['', Validators.required],
      userEmail: ['', [Validators.required, Validators.email]],
      userTel: ['', Validators.required],
      userAdresse: ['', Validators.required],
      userCp: ['', Validators.required],
      userVille: ['', Validators.required],
      userComment: [''],
      userAcceptTerms: [false, Validators.requiredTrue]

    });
  }


  /*
get formControl for fields
*/
  get f() { return this.informationForm.controls; }
  openDialog(demande: string) {
    const dialogRef = this.dialog.open(DevisFormComponent, {
      data: { name: demande }
    });



    dialogRef.afterClosed().subscribe(result => {

    });

  }
}
